import { InjectionToken } from '@angular/core';
import { ApiModuleConfig } from '@gelato-api-ui/sdk/src/lib/api/api-module-config';

export const APPLICATION = new InjectionToken<ApiModuleConfig>('sdk.app.name');

export enum Application {
  dashboard = 'dashboard',
  gelatoCom = 'gelatoCom',
}
